<template>
  <el-dialog
    :close-on-click-modal="false"
    title="批量制单"
    :visible.sync="visible"
    width="800px"
    class="remarkDialog"
    :before-close="handleClose"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="108px">
      <el-form-item label="揽货方式：" prop="shipWay">
        <el-radio-group v-model="form.shipWay">
          <el-radio label="01">快递取件</el-radio>
          <el-radio label="02">自行寄件</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small"> 确定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import { batchShippingOrder } from "@/api/order/all"

export default {
  name: "SendOrderShopeeBatch",
  data() {
    return {
      form: {
        appIds: "",
        shipWay: "01",
      },
      rules: {
        shipWay: [
          { required: true, message: "请选择揽货方式", trigger: "blur" },
        ],
      },
      addressList: [],
      pickupTimeList: [],
      address: "",
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    appIds: {
      type: String,
      default() {
        return ""
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    async visible() {
      if (this.visible) {
        this.form = {
          appIds: this.appIds,
          shipWay: "01",
        }
      }
    },
  },
  methods: {
    sure() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.startLoading()
          batchShippingOrder(this.form)
            .then((response) => {
              if (response.code == "200") {
                
                this.msgSuccess(response.msg)
              } else {
                this.msgError("提交失败！")
              }
              this.endLoading()
              this.$emit("onClose", this.form)
            })
            .catch(() => {
              this.endLoading()
            })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.color {
  padding: 1px;
  margin: 3px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 4px;
  border: 1px solid #eee;
}

.color.active {
  border: 1px solid #333;
}

.color-inner {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}
</style>
